import { Dialog, styled } from '@mui/material';

export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiPaper-root': {
    flex: 1,
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));
